import Alpine from "alpinejs"
import Swiper from "swiper"
import { Navigation } from "swiper/modules"

Alpine.data('GalleryCarousel', () => ({
    init(){
        const swiper = new Swiper('.galleryCarousel', {
            modules: [Navigation],
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            spaceBetween: 20,
            breakpoints: {
                450: {
                    centeredSlides: false,
                    slidesPerView: 1.5,
                    slidesPerGroup: 1
                },
                768: {
                    centeredSlides: false,
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                1024: {
                    centeredSlides: false,
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            }
        });
    }
}))